import * as React from 'react'
import { Card, Form } from 'react-bootstrap'

interface Props {
  name: string
  label1: string
  label2: string
  value1: string
  value2: string
  checked?: string
  defaultCheckedValue?: string
  className?: string
  style?: React.CSSProperties
  setValue?: (value: string) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  ariaControls?: string
}

const Component: React.FC<Props> = ({ name, label1, label2, value1, value2, checked, defaultCheckedValue, className, style, setValue, onChange, ariaControls }) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  return (
    <div id={`input_item_id_${name}`} className={`d-flex gap-3 ${className ?? ''}`} style={style}>
      <Form.Check className="flex-fill">
        <Form.Label className="w-100">
          <Card body>
            <Form.Check
              id={`radio-${name}-1`}
              name={name}
              value={value1}
              type="radio"
              label={label1}
              checked={checked != null ? checked === value1 : undefined}
              defaultChecked={defaultCheckedValue != null ? defaultCheckedValue === value1 : undefined}
              onChange={originalOnChange}
              aria-controls={ariaControls}
            />
          </Card>
        </Form.Label>
      </Form.Check>
      <Form.Check className="flex-fill">
        <Form.Label className="w-100">
          <Card body>
            <Form.Check
              id={`radio-${name}-2`}
              name={name}
              value={value2}
              type="radio"
              label={label2}
              checked={checked != null ? checked === value2 : undefined}
              defaultChecked={defaultCheckedValue != null ? defaultCheckedValue === value2 : undefined}
              onChange={originalOnChange}
              aria-controls={ariaControls}
            />
          </Card>
        </Form.Label>
      </Form.Check>
    </div>
  )
}

export default Component
